import axios from "axios";

export default {
    getRateCards(language, postalCode, type, energy, date, product, campaign = null, promo = null) {

        let query = `?language=${language}`
        query += `&postCode=${postalCode}`
        query += `&customerType=${type}`
        query += `&energy=${energy}`;
        query += `&date=${date}`
        query += `&product=${product}`

        if(campaign) {
            query += `&campaign=${campaign}`
        }

        if(promo) {
            query += `&promo=${promo}`
        }

        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: `${process.env.RATE_SERVICE_PUBLIC_PATH}/rate` + query
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error.response));
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/rateService.js